import { BatchRequest, ExternalScriptExecuteResult } from ".";

export class BatchResult {
  request: BatchRequest;
  result: ExternalScriptExecuteResult;
}
